import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class UserResetPasswordTokenModel extends FondationsServiceModel {
	static get path(): string {
		return '/users/reset_password/token';
	}
}
